import { usePageMeta, Reveal } from '../lib/site';
import { CardHeader, CtaBand } from '../components/Bits';
import slackImg from '../assets/team/slack.jpg';
import kjImg from '../assets/team/kj.jpg';
import dunnImg from '../assets/team/dunn.jpg';
import carsonImg from '../assets/team/carson.jpg';
import kinnonImg from '../assets/team/kinnon.jpg';

const TEAM = [
  [slackImg, 'Nate Slack', 'Chief Sales Officer'],
  [kjImg, 'KJ Roudebush', 'Chief Revenue Officer'],
  [dunnImg, 'Jacob Dunn', 'Chief Financial Officer'],
  [carsonImg, 'Carson Dolezal', 'Chief Technology Officer'],
  [kinnonImg, 'Kinnon Roudebush', 'Director of Supplier and Implementation Services'],
];

export default function About() {
  usePageMeta(
    'About | MyGolfLinks',
    'MyGolfLinks is an Indiana golf technology company building one platform for the public and municipal courses where most golf is actually played.'
  );

  return (
    <main>
      <section style={{ padding: 'clamp(140px, 16vw, 180px) 0 clamp(48px, 6vw, 72px)' }}>
        <div className="wrap">
          <Reveal>
            <p className="mono" style={{ fontSize: 12.5, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--fairway)', fontWeight: 500, marginBottom: 20 }}>
              About
            </p>
            <h1 className="display" style={{ maxWidth: 860 }}>
              Built in Indiana, for the courses everyone actually plays.
            </h1>
          </Reveal>
        </div>
      </section>

      <section>
        <div className="wrap" style={{ padding: '0 clamp(20px, 4.5vw, 44px) clamp(64px, 8vw, 100px)' }}>
          <Reveal style={{ maxWidth: 720 }}>
            <CardHeader no="01" label="The thesis" />
            <div style={{ display: 'grid', gap: 20, fontSize: '1.05rem', lineHeight: 1.75, color: 'var(--mut)' }}>
              <p>
                Most golf in America is not played behind a gate. It is played at public and
                municipal courses run by small crews who mow at dawn, work the counter at noon, and
                close the register at dark. That is the golf we come from, and that is who
                MyGolfLinks is built for.
              </p>
              <p>
                The software those courses get offered tends to come with a catch: inventory taken
                as payment, parity clauses on their own website, fees stapled onto their golfers'
                checkout, and an invoice that grows a module at a time. The industry taught
                everyone to accept that as normal.
              </p>
              <p>
                We think the fix is boring and honest. One platform that connects the golfer, the
                course, and the supplier. A flat plan price published on the website. Small
                transaction fees that only grow when the course's revenue does. No barter, no
                parity, nothing charged to the golfer at checkout.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="band-pine on-pine">
        <div className="wrap" style={{ padding: 'clamp(56px, 7vw, 84px) clamp(20px, 4.5vw, 44px)' }}>
          <Reveal style={{ maxWidth: 720 }}>
            <CardHeader no="02" label="How we make money" dark />
            <h2 className="h2">Aligned, on purpose</h2>
            <p className="lede" style={{ marginTop: 16 }}>
              LinksOS at $197 a month for smaller courses, LinksOS+ at $495 for mid-size and large,
              everything included. A flat $1.80 booking fee when a golfer books through the app,
              and nothing on bookings through your own website. Supplier platform fees are paid by
              the supplier, not the course. Per-transaction fees on Flash Deals and POS sales are
              finalized at launch. That is the entire business model, and it only works if your tee
              sheet fills.
            </p>
          </Reveal>
        </div>
      </section>

      <section>
        <div className="wrap" style={{ padding: 'clamp(64px, 8vw, 100px) clamp(20px, 4.5vw, 44px)' }}>
          <Reveal style={{ maxWidth: 720 }}>
            <CardHeader no="03" label="The team" />
            <h2 className="h2">Small team. Short distance to the builders.</h2>
            <p className="lede" style={{ marginTop: 16 }}>
              There is no sales floor and no ticket queue between you and the people who build the
              product. The people on your demo call are the people who ship the software, usually
              that same week. Founding courses feel that difference immediately: ask for something
              on Tuesday, see it Friday.
            </p>
          </Reveal>
          <Reveal
            d={1}
            style={{
              marginTop: 44, display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
              gap: 'clamp(18px, 3vw, 32px)', maxWidth: 940,
            }}
          >
            {TEAM.map(([img, name, role]) => (
              <div key={name}>
                <img
                  src={img}
                  alt={`${name}, ${role} at MyGolfLinks`}
                  width="512"
                  height="512"
                  style={{ width: '100%', height: 'auto', borderRadius: 12, display: 'block' }}
                />
                <div style={{ fontWeight: 750, fontSize: '1rem', marginTop: 12, letterSpacing: '-0.01em' }}>{name}</div>
                <div style={{ fontSize: '0.82rem', color: 'var(--mut)', marginTop: 2, lineHeight: 1.4 }}>{role}</div>
              </div>
            ))}
          </Reveal>
        </div>
      </section>

      <CtaBand
        title="Meet us on a call"
        sub="Thirty minutes, straight answers, and a live walk through the platform. If it isn't a fit, we'll tell you that too."
      />
    </main>
  );
}
